/*
  Shared Trustpilot testimonial source — single source of truth for
  every "what customers say" carousel on the site (Home + Urgent
  Excellence section, Quality-guarantee LanguexExcellence section).
  Refresh in one place, all surfaces update on next deploy.

  Sourcing rules (so this file doesn't drift into marketing fiction):

  1. Every entry MUST be a real verified review from the live
     Trustpilot profile:  https://www.trustpilot.com/review/www.languex.co
  2. `text` and `title` are quoted verbatim from the review. Light
     trimming is OK (truncating long quotes with an ellipsis) but
     do not paraphrase.
  3. `name` should be the reviewer's display name from Trustpilot
     IF visible AND we have permission to reproduce it. When the
     profile only shows the verified badge without a clear name,
     use "Verified customer" — this matches Trustpilot's own
     embed convention and avoids inventing attribution.
  4. `date` is the actual review date from the profile. Don't
     synthesize "2 days ago" — that ages badly and reads as fake
     after a week.
  5. Keep the set DIVERSE (repeat customer / use case / praise
     angle) so the carousel doesn't feel monotone.

  Last refresh: 2026-05-25 — pulled from live Trustpilot scrape.
  Next refresh: when the Trustpilot count rolls past a milestone
  (e.g. 2,000 reviews) OR every quarter, whichever is sooner.
*/

export type Testimonial = {
  /** Reviewer display name. Use "Verified customer" when the
      profile doesn't expose a clear name we have permission to use. */
  name: string;
  /** Verbatim review title from Trustpilot. */
  title: string;
  /** Verbatim review body. Light trimming with "…" is OK. */
  text: string;
  /** 1-5 stars. Should always be 5 for the front-page carousel —
      we're not pulling negative reviews into a hero surface. */
  rating: number;
  /** Actual date string ("Mar 3, 2026"), not "2 days ago". */
  date: string;
};

export const trustpilotTestimonials: Testimonial[] = [
  {
    name: "Verified customer",
    title: "Fast, Reliable, and Excellent Customer Service",
    text:
      "I've completed more than six documents with this company, and every single time the experience has been smooth. They are very fast and responsive, which is extremely important when you're working with important documents. Their customer service is outstanding — friendly, helpful, and truly professional.",
    rating: 5,
    date: "Mar 3, 2026",
  },
  {
    name: "Verified customer",
    title: "Quality services at good prices",
    text:
      "The translation was completed within the agreed timeframe. Fast feedback from the project manager. My experience with the company is successful. I would like to note separately the work of the project manager Imran — work with him was constructive and high-quality.",
    rating: 5,
    date: "Jun 10, 2025",
  },
  {
    name: "Verified customer",
    title: "Great experience with Languex",
    text:
      "They helped me translate my documents quickly and professionally. The communication was excellent — fast responses and clear instructions. Everything was delivered on time, and the whole process was smooth and stress-free. Highly recommend their service to anyone who needs certified translations!",
    rating: 5,
    date: "May 29, 2025",
  },
];
